<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        offset-sm="6"
        md="6"
        offset-md="6"
        lg="5"
        offset-lg="6"
      >
        <login-menu 
          @openGuestDialog="showGuestDialog = !showGuestDialog"
          @openConfigDialog="showConfigDialog = !showConfigDialog"/>
      </v-col>
    </v-row>
    
    <config-api :showDialog="showConfigDialog"
      @closeConfigDialog="showConfigDialog = !showConfigDialog" />
    <guest-login :showGuestDialog="showGuestDialog" 
      @closeGuestLogin="showGuestDialog = !showGuestDialog"/>
  
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GuestLogin from '@/components/unique/login/GuestLogin';
import LoginMenu from '@/components/unique/login/LoginMenu';
import ConfigAPI from '@/components/unique/login/ConfigAPI';
export default {
  components: {
    GuestLogin,
    LoginMenu,
    'config-api' : ConfigAPI
  },
  data: () => {
    return {
      showGuestDialog: false,
      showConfigDialog: false,
    }
  },
  methods: {
    ...mapActions({
      setApiURL: 'systemModule/setApiURL',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage'      
    }),
  },
}
</script>

<style></style>
